export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";